import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { GetDefaultMiddleware } from '@reduxjs/toolkit/src/getDefaultMiddleware';
import { sharedStoreConfig, branchSlice, userSlice } from '@gif/shared-rtk';
import { oktaApi } from '@gif/shared-apis';
import { feenApi, arcadeCerberusApi, arcadeGarrisonApi } from './api';

export const storeConfig = {
  reducer: {
    [userSlice.reducerPath]: userSlice.reducer,
    [branchSlice.reducerPath]: branchSlice.reducer,
    [arcadeCerberusApi.reducerPath]: arcadeCerberusApi.reducer,
    [arcadeGarrisonApi.reducerPath]: arcadeGarrisonApi.reducer,
    [feenApi.reducerPath]: feenApi.reducer,
    [oktaApi.reducerPath]: oktaApi.reducer,
    ...sharedStoreConfig.reducer,
  },
  middleware: (getDefaultMiddleware: GetDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      arcadeCerberusApi.middleware,
      arcadeGarrisonApi.middleware,
      feenApi.middleware,
      oktaApi.middleware,
      ...sharedStoreConfig.middleware,
    ]),
};
export const store = configureStore(storeConfig);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

setupListeners(store.dispatch);
